import { useState, useEffect } from "react";
import drupal from "../apis/drupal";

const useResources = resource => {
  const [resources, setResources] = useState([]);

  const fetchResource = async resource => {
    //const res = await axios.get(`${process.env.REACT_APP_API}${resource}`);
    const res = await drupal.get(`/${resource}`);
    setResources(res.data);
  };

  useEffect(() => {
    fetchResource(resource);
  }, [resource]);

  return resources;
};

export default useResources;
